export enum BeanSize {
  VeryLarge = 1,
  Large = 2,
  Medium = 3,
  Small = 4,
  Shells = 5,
}

export const BeanSizeString = {
  [BeanSize.VeryLarge]: 'inventory.beansizeverylarge',
  [BeanSize.Large]: 'inventory.beansizelarge',
  [BeanSize.Medium]: 'inventory.beansizemedium',
  [BeanSize.Small]: 'inventory.beansizesmall',
  [BeanSize.Shells]: 'inventory.beansizeshells',
}
